import { useFormState, useFormApi } from 'informed';
import { useEffect, useState } from 'react';

import { LoginData } from '../../../../types/TymbeApi';
import { addPlusToPhone } from '../../../../utils/phoneNumber';
import { TyInput } from '@tymbe/ui-forms';
import { ActionIcon } from '@tymbe/ui-icons';

export interface ActivateUserFormValues extends LoginData {
  re_password: string,
  phone?: string,
  position?: string,
}

type ActivateUserFormProps = {
  user: LoginData
};

type VisibilityState = {
  password: boolean,
  re_password: boolean,
}

const ActivateUserForm = ({ user }: ActivateUserFormProps) => {
  const formState = useFormState<ActivateUserFormValues>();
  const formApi = useFormApi<ActivateUserFormValues>();
  const [visiblePassword, setVisiblePassword] = useState<VisibilityState>({
    password: false,
    re_password: false,
  });

  const validatePasswordFormat = (val: string | number) => {
    if (!val || String(val).length < 6) {
      return 'Minimální délka hesla je 6 znaků';
    }
    return undefined;
  };

  const validatePasswordMatch = (repswd: string | number) => (
    repswd !== formState.values.password ? 'Hesla se neshodují' : undefined
  );

  const toggleShowPassword = (field: keyof VisibilityState) => () => {
    setVisiblePassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }

  useEffect(() => {
    if (!user) return;
    formApi.setValues({
      ...user,
      phone: addPlusToPhone(user?.person?.contact?.find((cntct) => cntct.type === 'mobile_phone')?.value),
      position: user?.person?.company?.[0]?.title,
    });
  }, [formApi, user]);

  return (
    <div className="flex lg:flex-row flex-col gap-10">
      <div className="flex flex-col gap-2 lg:min-w-[42%]">
        <div className="flex flex-row gap-2 flex-wrap">
          <TyInput
            className="w-full md:flex-1"
            type="text"
            name="person.first_name"
            label="Jméno"
            required
            disabled
          />
          <TyInput
            className="w-full md:flex-1"
            type="text"
            name="person.last_name"
            label="Příjmení"
            required
            disabled
          />
        </div>
        <TyInput
          name="username"
          type="email"
          label="Email"
          disabled
          required
        />
        <TyInput
          name="phone"
          type="phone"
          label="Telefon"
          disabled
        />
        <>
          <TyInput
            name="password"
            type={visiblePassword.password ? 'text' : 'password'}
            label="Heslo"
            validate={validatePasswordFormat}
            validateOn="change"
            suffix={<ActionIcon name={visiblePassword.password ? 'visibility_off' : 'visibility'} onClick={toggleShowPassword('password')} />}
            required
          />
          <TyInput
            name="re_password"
            type={visiblePassword.re_password ? 'text' : 'password'}
            label="Heslo znovu"
            validate={validatePasswordMatch}
            validateOn="blur-submit"
            suffix={<ActionIcon name={visiblePassword.re_password ? 'visibility_off' : 'visibility'} onClick={toggleShowPassword('re_password')} />}
            required
          />
        </>
        <TyInput
          name="position"
          type="text"
          label="Pozice"
          disabled
        />
      </div>
    </div>
  );
};

export default ActivateUserForm;
